import { fetchTeamsFail, fetchTeamsSuccess } from './actions';
import { put } from 'redux-saga/effects';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { getTeams } from '../team.backend';

export function* fetchTeamsSaga() {
    try {
        const response = yield getTeams();
        yield put(fetchTeamsSuccess(response.data));
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchTeamsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
